import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h6" color="error" sx={{ mb: 2 }}>
                        Something went wrong while loading this page.
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                        {this.state.error?.message}
                    </Typography>
                    <Button variant="outlined" onClick={() => this.setState({ hasError: false, error: null })}>
                        Try Again
                    </Button>
                </Box>
            );
        }
        return this.props.children;
    }
}
